import { Injectable } from '@angular/core';
import { McticHttpClient } from '@mctic/ng-core';
import { FaturamentoBruto } from '../shared/model/';
import { FaturamentoBrutoPadis } from '../shared/model/faturamento-bruto-padis.model';

@Injectable({
  providedIn: 'root'
})

export class FaturamentoBrutoService {

  private readonly endpoint = '/sepin-backend/rest/faturamento-bruto';

  constructor(private readonly http: McticHttpClient) {
  }

  obterFaturamentoBruto() {
    return this.http.get<FaturamentoBruto>(this.endpoint);
  }

  obterFaturamentoBrutoPadis() {
    return this.http.get<FaturamentoBrutoPadis>(`${this.endpoint}/padis`);
  }

  obterValoresTotais() {
    return this.http.get<any>(`${this.endpoint}/totais`);
  }

  salvarFaturamentoBruto(faturamentoBruto: FaturamentoBruto) {
    return this.http.post(this.endpoint, faturamentoBruto);
  }

  salvarFaturamentoBrutoPadis(faturamentoBruto: FaturamentoBrutoPadis) {
    return this.http.post(`${this.endpoint}/padis`, faturamentoBruto);
  }
}
